@if (tags.includes('Primary'); as hasPrimaryTag) {
  <glxy-badge [color]="'blue'">{{ tags[0] }}</glxy-badge>
  @if (tags.length > 1) {
    <glxy-badge [color]="'grey'">{{ tags[1] }}</glxy-badge>
  }
} @else {
  @if (tags.length >= 1) {
    <glxy-badge [color]="'grey'">{{ tags[0] }}</glxy-badge>
  }
  @if (tags.length >= 2) {
    <glxy-badge [color]="'grey'">{{ tags[1] }}</glxy-badge>
  }
}

@if (!hasPrimaryTag) {
  <ng-container *ngTemplateOutlet="noPrimaryTagsAlt"></ng-container>
}
@if (hasPrimaryTag) {
  <ng-container *ngTemplateOutlet="hasPrimaryTag"></ng-container>
}


<ng-template #hasPrimaryTag>
  @if (tags.length >= 3) {
    <glxy-badge [glxyTooltip]="tags.slice(2).join(', ')">+{{ tags.length - 2 }}</glxy-badge>
  }
</ng-template>

<ng-template #noPrimaryTagsAlt>
  @if (tags.length >= 3) {
    <glxy-badge [glxyTooltip]="tags.slice(2).join(', ')">+{{ tags.length - 2 }}</glxy-badge>
  }
</ng-template>
